import { AnyAction, Dispatch, MiddlewareAPI, SerializedError } from '@reduxjs/toolkit';
import { ThunkMiddleware } from 'redux-thunk';
import { RootState } from '../store';
import slice, { selectors } from './store-front-auth.slice';

export const handleHttpResponseMiddleware: ThunkMiddleware =
  (middlewareAPI: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
    const state: RootState = middlewareAPI.getState();

    if (isUserFromStoreFront(state) && isUnauthorizedResponse(action.error)) {
      alert('The link has expired. Please login again');
      next(slice.actions.logout());
    } else {
      next(action);
    }
  };

function isUserFromStoreFront(state: RootState): boolean {
  return selectors.selectIsLoggedIn(state.storeFrontAuth);
}

function isUnauthorizedResponse(error: SerializedError): boolean {
  if (!error) {
    return false;
  }

  return ['401', '403'].includes(error.code!);
}
